export const FACEBOOK_PIXEL_ID = 1190945128545704;
